<mat-form-field>
  <input #inputField
    type="text"
    matInput
    [placeholder]="placeholder"
    [formControl]="searchControl"
    [matAutocomplete]="auto"
    class="truncate-text">

  <mat-autocomplete #auto="matAutocomplete"
    (optionSelected)="onSelectionChange($event)"
    (closed)="onDropdownClosed()"
    [panelWidth]="panelWidth">

    <!-- Grouped display mode -->
    @if (grouped) {
      @for (group of filteredGroups | keyvalue; track group) {
        <mat-optgroup
          [label]="group.key"
          class="bold-optgroup">
          @for (subtype of group.value; track subtype) {
            <mat-option [value]="subtype.id">
              {{subtype.name}}
            </mat-option>
          }
        </mat-optgroup>
      }
    }

    <!-- Flat display mode -->
    @if (!grouped) {
      @for (subtype of filteredFlat; track subtype) {
        <mat-option [value]="subtype.id">
          {{subtype.name}}
        </mat-option>
      }
    }
  </mat-autocomplete>
</mat-form-field>